import { column, edge, flow, makeFlow, node } from "../builders";
import type { TemplateDef } from "../types";

const seq = column("f1", 100, 70, 92, [
  ["t1", "auto-trigger", "Order placed", { props: { triggerType: "Order Submitted", event: "Any product" } }],
  ["e1", "auto-email", "Order confirmed + what happens next", { props: { subject: "Order #{{order.number}} confirmed" } }],
  ["w1", "auto-wait", "Wait 3 days", { props: { duration: "3", unit: "days" } }],
  ["e2", "auto-email", "Shipped — track it here", { props: { subject: "It's on the way" } }],
  ["w2", "auto-wait", "Wait 10 days", { props: { duration: "10", unit: "days" } }],
  ["s1", "auto-sms", "How's it going?", { props: { message: "Hi {{contact.first_name}} — how are you getting on with your order? Reply 1-5" } }],
  ["c1", "auto-condition", "Rated 4 or 5?", { props: { condition: "review_rating is greater than 3" } }],
  ["e3", "auto-email", "Leave a public review", { props: { subject: "30 seconds? It genuinely helps" } }],
  ["tg", "auto-tag-add", "Tag: promoter", { props: { tag: "promoter" } }],
]);

const def: TemplateDef = {
  slug: "post-purchase-review-request",
  name: "Post-Purchase + Review Request",
  category: "E-commerce",
  tagline:
    "Confirm, ship, then ask — and only send the happy customers to the public review page.",
  description:
    "A free post-purchase template: order confirmation and shipping emails, a private rating text after delivery, and a branch that sends only the satisfied buyers to your public review page while unhappy ones reach a human first. Clone it into FrazzleCRM and it runs off your store's order webhook.",
  whatsInside: [
    "Order-submitted trigger with confirmation and shipping emails",
    "A private rating SMS timed to land after delivery, not after checkout",
    "Rating branch: public review ask for 4-5s, a real reply for the rest",
    "Promoter tag for the buyers worth asking for referrals and UGC",
  ],
  flow: makeFlow(
    [
      node("sh", "prov-shopify", "Shopify", 40, 60),
      node("co", "page-checkout", "Checkout", 40, 220, { props: { price: "$79" } }),
      node("ty", "page-thankyou", "Order complete", 360, 140),
      flow("f1", "Post-Purchase", 680, 40, 420, 948),
      ...seq.nodes,
      node("rv", "page-web", "Public review page", 1200, 260, { url: "https://g.page/r/your-review-link" }),
      node("out", "outcome-sale", "Repeat purchase", 1520, 260, { props: { value: "$79" } }),
      node("n1", "util-note", "Ask after delivery, not after payment", 360, 340, {
        notes:
          "A review request sent at checkout asks about a box that hasn't arrived. Time the ask to delivery plus a few days of actual use and the ratings tell the truth.",
      }),
    ],
    [
      edge("sh", "ty"),
      edge("co", "ty"),
      edge("ty", "f1"),
      ...seq.edges,
      edge("f1", "rv"),
      edge("rv", "out"),
    ]
  ),
};

export default def;
